export default __webpack_public_path__ + "images/switch.ea7692b14e1db65cdd575e5b003b1fe2.png";